/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gf_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RCF = 1.118 × 10⁻⁵ × r × N², where r is the rotor radius in cm and N is the speed in RPM. Rearranged, N = √(RCF ÷ (1.118 × 10⁻⁵ × r)).`)
};

const es_gf_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RCF = 1.118 × 10⁻⁵ × r × N², donde r es el radio del rotor en cm y N es la velocidad en RPM. Reordenando, N = √(RCF ÷ (1.118 × 10⁻⁵ × r)).`)
};

const de_gf_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RCF = 1,118 × 10⁻⁵ × r × N², wobei r der Rotorradius in cm und N die Drehzahl in RPM ist. Umgestellt: N = √(RCF ÷ (1,118 × 10⁻⁵ × r)).`)
};

const nl_gf_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RCF = 1,118 × 10⁻⁵ × r × N², waarbij r de rotorstraal in cm is en N de snelheid in RPM. Herschikt: N = √(RCF ÷ (1,118 × 10⁻⁵ × r)).`)
};

const fr_gf_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RCF = 1,118 × 10⁻⁵ × r × N², où r est le rayon du rotor en cm et N la vitesse en RPM. En réarrangeant, N = √(RCF ÷ (1,118 × 10⁻⁵ × r)).`)
};

const it_gf_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RCF = 1.118 × 10⁻⁵ × r × N², dove r è il raggio del rotore in cm e N è la velocità in RPM. Riorganizzando, N = √(RCF ÷ (1.118 × 10⁻⁵ × r)).`)
};

const pt_br2_gf_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RCF = 1,118 × 10⁻⁵ × r × N², em que r é o raio do rotor em cm e N é a velocidade em RPM. Rearranjando, N = √(RCF ÷ (1,118 × 10⁻⁵ × r)).`)
};

const pt_gf_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RCF = 1.118 × 10⁻⁵ × r × N², em que r é o raio do rotor em cm e N é a velocidade em RPM. Rearranjando, N = √(RCF ÷ (1.118 × 10⁻⁵ × r)).`)
};

const ja_gf_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RCF = 1.118 × 10⁻⁵ × r × N²(rはローター半径[cm]、Nは回転速度[RPM])です。式を変形すると、N = √(RCF ÷ (1.118 × 10⁻⁵ × r))となります。`)
};

const zh_gf_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`RCF = 1.118 × 10⁻⁵ × r × N²，其中 r 为转子半径（cm），N 为转速（RPM）。反推可得 N = √(RCF ÷ (1.118 × 10⁻⁵ × r))。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gf_faq_a4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gf_faq_a4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gf_faq_a4", locale)
	if (locale === "en") return en_gf_faq_a4(inputs)
	if (locale === "es") return es_gf_faq_a4(inputs)
	if (locale === "de") return de_gf_faq_a4(inputs)
	if (locale === "nl") return nl_gf_faq_a4(inputs)
	if (locale === "fr") return fr_gf_faq_a4(inputs)
	if (locale === "it") return it_gf_faq_a4(inputs)
	if (locale === "pt-BR") return pt_br2_gf_faq_a4(inputs)
	if (locale === "pt") return pt_gf_faq_a4(inputs)
	if (locale === "ja") return ja_gf_faq_a4(inputs)
	return zh_gf_faq_a4(inputs)
};